// Revisado: 2026-01-12 Skill Type & Range Filters
import React from 'react';
import { useTranslation } from 'react-i18next';

// B1 — Pills de tipo con color activo/inactivo para cada categoría
const SKILL_TYPE_PILLS = [
    { value: 'Unique Skills', label: 'Unique', active: 'bg-yellow-500 text-white border-yellow-500', idle: 'bg-yellow-50 text-yellow-700 border-yellow-200 hover:border-yellow-400 dark:bg-yellow-900/20 dark:text-yellow-300 dark:border-yellow-800' },
    { value: 'Inherited Skills', label: 'Inherited', active: 'bg-gray-600 text-white border-gray-600', idle: 'bg-gray-50 text-gray-600 border-gray-200 hover:border-gray-400 dark:bg-gray-700/40 dark:text-gray-300 dark:border-gray-600' },
    { value: 'Green Skills', label: 'Green', active: 'bg-green-500 text-white border-green-500', idle: 'bg-green-50 text-green-700 border-green-200 hover:border-green-400 dark:bg-green-900/20 dark:text-green-300 dark:border-green-800' },
    { value: 'Blue Skills', label: 'Blue', active: 'bg-blue-500 text-white border-blue-500', idle: 'bg-blue-50 text-blue-700 border-blue-200 hover:border-blue-400 dark:bg-blue-900/20 dark:text-blue-300 dark:border-blue-800' },
    { value: 'Red Skills', label: 'Red', active: 'bg-red-500 text-white border-red-500', idle: 'bg-red-50 text-red-700 border-red-200 hover:border-red-400 dark:bg-red-900/20 dark:text-red-300 dark:border-red-800' },
    { value: 'Orange Skills', label: 'Orange', active: 'bg-orange-500 text-white border-orange-500', idle: 'bg-orange-50 text-orange-700 border-orange-200 hover:border-orange-400 dark:bg-orange-900/20 dark:text-orange-300 dark:border-orange-800' },
    { value: 'Purple Skills', label: 'Purple', active: 'bg-purple-500 text-white border-purple-500', idle: 'bg-purple-50 text-purple-700 border-purple-200 hover:border-purple-400 dark:bg-purple-900/20 dark:text-purple-300 dark:border-purple-800' },
    { value: 'Gold skills', label: 'Gold', active: 'bg-amber-500 text-white border-amber-500', idle: 'bg-amber-50 text-amber-700 border-amber-200 hover:border-amber-400 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800' },
    { value: 'Scenario Gold Skill', label: 'Scen. Gold', active: 'bg-amber-700 text-white border-amber-700', idle: 'bg-amber-100 text-amber-800 border-amber-300 hover:border-amber-500 dark:bg-amber-900/30 dark:text-amber-200 dark:border-amber-700' },
    { value: 'Evolution Skills', label: 'Evolution', active: 'bg-pink-500 text-white border-pink-500', idle: 'bg-pink-50 text-pink-700 border-pink-200 hover:border-pink-400 dark:bg-pink-900/20 dark:text-pink-300 dark:border-pink-800' },
];

// B2 — Firma del componente con prop onClearAll
const SkillSearch = ({
    searchTerm,
    onSearchChange,
    selectedColor,
    onColorChange,
    costMin,
    onCostMinChange,
    costMax,
    onCostMaxChange,
    scoreMin,
    onScoreMinChange,
    scoreMax,
    onScoreMaxChange,
    totalCount,
    filteredCount,
    onClearAll
}) => {
    const { t } = useTranslation();

    return (
        <div className="space-y-4">
            <div className="flex flex-col gap-4">
                {/* Top Row: Search Input */}
                <div className="relative flex-grow">
                    <input
                        type="text"
                        placeholder={t('SkillManagementSearch.placeholder')}
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="w-full px-4 py-3 pl-12 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-green focus:border-primary-green outline-none dark:bg-gray-700 dark:text-gray-100"
                    />
                    <svg
                        className="absolute left-4 top-3.5 h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>

                    {/* Clear button */}
                    {searchTerm && (
                        <button
                            onClick={() => onSearchChange('')}
                            className="absolute right-4 top-3.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                            aria-label={t('SkillManagementSearch.clear_search')}
                        >
                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </div>

                {/* B3 — Pills de tipo: reemplaza el <select> nativo */}
                <div className="flex flex-wrap gap-1.5">
                    <button
                        onClick={() => onColorChange('')}
                        className={`px-3 py-1 text-xs font-semibold rounded-full border whitespace-nowrap
                            ${!selectedColor
                                ? 'bg-gray-800 text-white border-gray-800 dark:bg-white dark:text-gray-900 dark:border-white'
                                : 'bg-white text-gray-500 border-gray-200 hover:border-gray-400 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700'
                            }`}
                    >
                        {t('SkillManagementSearch.all_types')}
                    </button>
                    {SKILL_TYPE_PILLS.map(({ value, label, active, idle }) => (
                        <button
                            key={value}
                            onClick={() => onColorChange(selectedColor === value ? '' : value)}
                            className={`px-3 py-1 text-xs font-semibold rounded-full border whitespace-nowrap
                                ${selectedColor === value ? active : idle}`}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {/* Range Filters Row */}
                <div className="flex flex-col md:flex-row gap-4">
                    {/* B5 — Cost Range: label encima + inputs sin borde interno */}
                    <div className="flex flex-col gap-1">
                        <span className="text-[10px] uppercase tracking-widest text-gray-400 dark:text-gray-500 font-semibold">Cost</span>
                        <div className="flex items-center gap-1.5 bg-white dark:bg-gray-800 px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-lg">
                            <svg className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <input
                                type="number"
                                placeholder="Min"
                                value={costMin}
                                onChange={(e) => onCostMinChange(e.target.value)}
                                className="w-16 bg-transparent border-0 text-sm text-center focus:outline-none text-gray-700 dark:text-gray-200 placeholder:text-gray-300"
                            />
                            <span className="text-gray-300 dark:text-gray-600">–</span>
                            <input
                                type="number"
                                placeholder="Max"
                                value={costMax}
                                onChange={(e) => onCostMaxChange(e.target.value)}
                                className="w-16 bg-transparent border-0 text-sm text-center focus:outline-none text-gray-700 dark:text-gray-200 placeholder:text-gray-300"
                            />
                        </div>
                    </div>

                    {/* B6 — Score Range: misma estructura que Cost */}
                    <div className="flex flex-col gap-1">
                        <span className="text-[10px] uppercase tracking-widest text-gray-400 dark:text-gray-500 font-semibold">Score</span>
                        <div className="flex items-center gap-1.5 bg-white dark:bg-gray-800 px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-lg">
                            <svg className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                            </svg>
                            <input
                                type="number"
                                placeholder="Min"
                                value={scoreMin}
                                onChange={(e) => onScoreMinChange(e.target.value)}
                                className="w-16 bg-transparent border-0 text-sm text-center focus:outline-none text-gray-700 dark:text-gray-200 placeholder:text-gray-300"
                            />
                            <span className="text-gray-300 dark:text-gray-600">–</span>
                            <input
                                type="number"
                                placeholder="Max"
                                value={scoreMax}
                                onChange={(e) => onScoreMaxChange(e.target.value)}
                                className="w-16 bg-transparent border-0 text-sm text-center focus:outline-none text-gray-700 dark:text-gray-200 placeholder:text-gray-300"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* B7 — Contador informativo + botón Limpiar */}
            <div className="flex items-center justify-between">
                <span className={`inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full border
                    ${filteredCount < totalCount
                        ? 'bg-primary-green/10 text-primary-green border-primary-green/30'
                        : 'bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700'
                    }`}>
                    <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${filteredCount < totalCount ? 'bg-primary-green' : 'bg-gray-400'}`} />
                    {t('SkillManagementSearch.showing_results', { filtered: filteredCount, total: totalCount })}
                </span>
                {(searchTerm || selectedColor || costMin || costMax || scoreMin || scoreMax) && (
                    <button
                        onClick={onClearAll}
                        className="text-xs text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                    >
                        {t('SkillManagementSearch.clear_filters')}
                    </button>
                )}
            </div>
        </div>
    );
};

export default SkillSearch;
// Revisado: 2026-01-12 Skill Type & Range Filters
